<template>
    <div class="root">
        <v-list-item-title class="font-weight-regular subtitle-2">
            Frequently used
        </v-list-item-title>
        <v-row
            v-for="(emoji, index) in emojiGroup('Frequently used')"
            :key="emoji + index"
            no-gutters
            class="white d-inline-flex "
        >
            <v-col
                class="px-2 py-1 hovering no-gutters"
                @click="selectEmoji(emoji)"
            >
                {{ emoji }}
            </v-col>
        </v-row>

        <v-list-item-title class="font-weight-regular subtitle-2">
            People
        </v-list-item-title>
        <v-row
            v-for="(emoji, index) in emojiGroup('People')"
            :key="emoji + index"
            no-gutters
            class="white d-inline-flex hovering"
        >
            <v-col
                class="px-2 py-1 hovering no-gutters"
                @click="selectEmoji(emoji)"
            >
                {{ emoji }}
            </v-col>
        </v-row>

        <v-list-item-title class="font-weight-regular subtitle-2">
            Nature
        </v-list-item-title>
        <v-row
            v-for="(emoji, index) in emojiGroup('Nature')"
            :key="emoji + index"
            no-gutters
            class="white d-inline-flex hovering"
        >
            <v-col
                class="px-2 py-1 hovering no-gutters"
                @click="selectEmoji(emoji)"
            >
                {{ emoji }}
            </v-col>
        </v-row>

        <v-list-item-title class="font-weight-regular subtitle-2">
            Objects
        </v-list-item-title>
        <v-row
            v-for="(emoji, index) in emojiGroup('Objects')"
            :key="emoji + index"
            no-gutters
            class="white d-inline-flex hovering"
        >
            <v-col
                class="px-2 py-1 hovering no-gutters"
                @click="selectEmoji(emoji)"
            >
                {{ emoji }}
            </v-col>
        </v-row>

        <v-list-item-title class="font-weight-regular subtitle-2">
            Places
        </v-list-item-title>
        <v-row
            v-for="(emoji, index) in emojiGroup('Places')"
            :key="emoji + index"
            no-gutters
            class="white d-inline-flex hovering"
        >
            <v-col
                class="px-2 py-1 hovering no-gutters"
                @click="selectEmoji(emoji)"
            >
                {{ emoji }}
            </v-col>
        </v-row>

        <v-list-item-title class="font-weight-regular subtitle-2">
            Symbols
        </v-list-item-title>
        <v-row
            v-for="(emoji, index) in emojiGroup('Symbols')"
            :key="emoji + index"
            no-gutters
            class="white d-inline-flex hovering"
        >
            <v-col
                class="px-2 py-1 hovering no-gutters"
                @click="selectEmoji(emoji)"
            >
                {{ emoji }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import emojis from "@/views/Task/emojis";

export default {
    setup(props, ctx) {
        function emojiGroup(type) {
            return Object.values(emojis[type]);
        }

        const selectEmoji = emoji => {
            ctx.emit("selectedEmoji", emoji);
        };

        return {
            emojis,
            emojiGroup,
            selectEmoji
        };
    }
};
</script>

<style scoped lang="scss">
.root {
    max-width: 204px;
    background: white;
    max-height: 224px;
    overflow: auto;
    padding: 4px;
}

.hovering {
    &:hover {
        cursor: pointer;
        background: var(--v-g4-base) !important;
    }
}
</style>
